/**
 * Created by Jerker Nord on 2024-02-23.
 */
import {LonerBigWildSymbol} from "./LonerBigWildSymbol";
import {LonerStatics} from "../../../../LonerStatics";
import {LonerSymbolStates} from "../../../../../core/reel/ReelInterfaces";
import {gsap} from "gsap";

export class LonerBigWildSymbol3x3 extends LonerBigWildSymbol {

    constructor() {
        super();
        this._bigSymContainer.position.x = 0 - LonerStatics.symbolWidth;
        this._bigSymContainer.position.y = 0 - (LonerStatics.symbolHeight + 20); //A little extra to adjust spin position
    }
}